module.exports = __webpack_public_path__ + "static/img/superhero_02.a8283f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/superhero_02.png
// module id = 1i0h
// module chunks = 0